import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "!mb-0 font-sans text-sm font-bold"
};
const _hoisted_2 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_3 = {
    key: 2,
    class: "font-bold"
};
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
import { computed, onMounted, toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventSessionInformation',
    props: {
        sessions: {
            type: Object,
            required: true,
        },
        hasLiveStream: {
            type: Boolean,
            required: false,
            default: false,
        },
        isManualEvent: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        const eventHasLiveStream = computed(() => {
            return props.hasLiveStream;
        });
        //check if any of the sessions startDate is the same as the endDate
        const justDateRange = computed(() => {
            const checkSessions = props.sessions.map((session) => {
                return session.startDate === session.endDate;
            });
            return !checkSessions.includes(true);
        });
        const { sessions } = toRefs(props);
        const createEventbriteWidgets = () => {
            // Create the Eventbrite widgets for each session
            sessions.value.forEach((session) => {
                const eventId = session.eventId;
                const modalTriggerElementId = `event-id-${session.eventId}`;
                // @ts-ignore
                window.EBWidgets.createWidget({
                    widgetType: 'checkout',
                    eventId,
                    modal: true,
                    modalTriggerElementId,
                });
            });
        };
        const isSoldOutButNoWaitList = (session) => {
            return session.isSoldOut && !session.waitlistAvailable;
        };
        const bookingText = (session) => {
            return (session.manualBookingText ||
                (session.waitlistAvailable ? 'Join waiting list' : 'Book now'));
        };
        const sessionHeader = (session) => {
            if (session.isLiveStream) {
                return 'Live Stream';
            }
            return 'Attend in Person';
        };
        const displayBookingButton = (session) => {
            return !props.isManualEvent || session.manualBookingUrl.length > 0;
        };
        const startAndEndDateTheSame = (session) => {
            return session.startDate === session.endDate;
        };
        onMounted(() => {
            if (!props.isManualEvent) {
                createEventbriteWidgets();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'xl:grid-cols-2': !justDateRange.value,
                    }, "lg:grid lg:grid-cols-1 lg:gap-x-6 lg:gap-y-10"]),
                "data-event-session-information": ""
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sessions), (session) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass({ 'col-span-full': !startAndEndDateTheSame(session) })
                    }, [
                        (eventHasLiveStream.value)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(sessionHeader(session)), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: _normalizeClass(["flex flex-row items-start justify-between gap-x-5", {
                                    'lg:block': startAndEndDateTheSame(session),
                                }])
                        }, [
                            _createElementVNode("p", {
                                class: _normalizeClass({ 'lg:mb-0': !startAndEndDateTheSame(session) })
                            }, [
                                (startAndEndDateTheSame(session))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(session.startDate) + " ", 1),
                                        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(session.timeRange), 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(session.dateRange), 1)
                                    ], 64))
                            ], 2),
                            (isSoldOutButNoWaitList(session))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Fully booked "))
                                : (displayBookingButton(session))
                                    ? (_openBlock(), _createBlock(ButtonWithArrow, {
                                        key: 1,
                                        id: `event-id-${session.eventId}`,
                                        class: "!text-left !text-white",
                                        text: bookingText(session),
                                        url: session.manualBookingUrl,
                                        target: session.manualBookingUrl ? '_blank' : ''
                                    }, null, 8, ["id", "text", "url", "target"]))
                                    : (session.manualBookingText)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(session.manualBookingText), 1))
                                        : _createCommentVNode("", true)
                        ], 2)
                    ], 2));
                }), 256))
            ], 2));
        };
    }
});
